import TenantAccountMenu from '../../../accountMenu/TenantAccountMenu'

interface Props {
  workspaceId: string
  contentProjectId: string
}

/** Canvas fullscreen shell — fixed top-right account menu (VistoeraTASK-00550). */
export default function GlobalAccountEntry({ workspaceId, contentProjectId }: Props) {
  return <TenantAccountMenu workspaceId={workspaceId} contentProjectId={contentProjectId} surface="canvas" />
}
